import { ICostSummaryItem, ILineItem } from '../../CartContext.types';

export const useDownPaymentHook = (lineItem: ILineItem): ICostSummaryItem | undefined => {
    if ((lineItem.device?.downPayment ?? 0) > 0) {
        const item: ICostSummaryItem = {
            lineNumber: lineItem.lineNumber,
            itemName: `${lineItem.device?.product.baseInfo.name} - Down Payment`,
            amount: lineItem.device?.downPayment ?? 0,
            type: 'cost'
        };
        return item;
    }
};
